import React, { useContext } from 'react'
import { Link, useParams } from 'react-router-dom'
import HeaderLogo from '../HeaderLogo'
import './index.css'
import { AuthContext } from '../../App.js'
import { ReactComponent as Close } from '../../assets/close.svg'
import { ReactComponent as Back } from '../../assets/back.svg'

const Header = ({ pageNumber, prevPage, onClose }) => {

  	const { resetPN, detailsList, setPageNumber, setPrevPage, resetCart } = useContext(AuthContext)
	const params = useParams()

	const handleReset = () => {
			resetCart()
			resetPN()
			if(prevPage===6){
				setPrevPage({prevPageNum:5})
			}
	} 
 
  	if(pageNumber===null){
  		return (
    		<div className="header_1">
	  			<HeaderLogo />
    		</div>
    		)
	}else{
   	return(
		<div style={{position:pageNumber===3||pageNumber===8||pageNumber===9||pageNumber===15?'fixed':'none', width:'100%', zIndex:'1'}}>
   			<div className="header_2">
	  			{pageNumber===1||pageNumber===3||pageNumber===5||pageNumber===7||pageNumber===8||pageNumber===9?
				  				<Link to={`/kekspos/${params.tid}`}><Back className="header-btn" onClick={()=>resetPN()}/></Link>:null}
				{pageNumber===2&&<Link to={`/kekspos/${params.tid}`}><Close className="header-btn" onClick={()=>handleReset()}/></Link>}
				{pageNumber===4&&<Link to={prevPage===3?`/kekspos/${params.tid}/povijest-transakcija`:`/kekspos/${params.tid}/izvjestaji`}><Back className="header-btn" onClick={()=>setPageNumber(prevPage)}/></Link>} 
				{pageNumber===6&&<Link to={`/kekspos/${params.tid}/qr-artikl`}><Back className="header-btn" onClick={()=>setPageNumber(5)}/></Link>}
				{pageNumber===10&&<Link to={`/kekspos/${params.tid}/detalji/${params.keks_id}`}><Back className="header-btn" onClick={()=>detailsList()}/></Link>}
				{pageNumber===11&&<Close className="header-btn" onClick={()=>onClose()}/>}
				{pageNumber===12&&<Back className="header-btn" onClick={()=>onClose()}/>}
				{pageNumber===13&&<Close className="header-btn" onClick={()=>onClose()}/>}
				{pageNumber===14&&<Back className="header-btn" onClick={()=>onClose()}/>}
				{pageNumber===15&&<Link to={`/kekspos/${params.tid}`}><Back className="header-btn" onClick={()=>resetPN()}/></Link>}
	  			{pageNumber===1&&<div className="header-text">Kreiraj QR kod sa iznosom</div>}
	  			{pageNumber===2&&<div className="header-text">QR kod za naplatu</div>}
				{pageNumber===3&&<div className="header-text">Povijest transakcija</div>}
				{pageNumber===4&&<div className="header-text">Više detalja</div>}
				{pageNumber===5&&<div className="header-text">Kreiraj QR kod sa artiklima</div>}
				{pageNumber===6&&<div className="header-text">Popis prizvoda na računu</div>}
				{pageNumber===7&&<div className="header-text">Izvještaji</div>}
				{pageNumber===8&&<div className="header-text">Upravljanje artiklima</div>}
				{pageNumber===9&&<div className="header-text">Upravljanje korisnicima</div>}
				{pageNumber===10&&<div className="header-text">Djelomični storno</div>}
				{pageNumber===11&&<div className="header-text">Dodaj novi proizvod</div>}
				{pageNumber===12&&<div className="header-text">Uredi proizvod</div>}
				{pageNumber===13&&<div className="header-text">Dodaj novog korisnika</div>}
				{pageNumber===14&&<div className="header-text">Uredi korisnika</div>}
				{pageNumber===15&&<div className="header-text">Uvjeti korištenja</div>}	 
    		</div>
		</div>
   	)
   }
  
}

export default Header
